import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function setPartner({
  dst,
  partner,
  operator,
}: {
  dst: PublicKey;
  partner: PublicKey;
  operator: PublicKey;
}) {
  const program = makeDSTProgram();
  const result = program.methods.setPartner().accountsPartial({
    operator,
    dst,
    partner,
  });

  return result;
}
